import { IUserContext } from '@truckdown/systems';
import registerLocations from '@truckdown/locations';

import './Services';
import './Images';
import './Components';

export { LocationUtilities } from './LocationUtilities';

export default {
    registerPrerequisites: (context: IUserContext) => {
        registerLocations(context);
    }
};
